import { useEffect, useRef, useState } from "react";
import {formBtn1,formBtn2,inputClass,pageClass,pageHeader} from "../Utils/CustomClasses";
import Table from "../Table/Table";
import Select from "react-select";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Checkbox } from "antd";
import { toast } from "react-toastify";
import {AddLeadGroupsAPI,GetAllCompanyAPI,GetallLeads2API,GetAllLeadsAPI,GetGroupsByCompanyAPI, StaticUserAPI} from "../../API/Api";
import { useLocation, useNavigate } from "react-router-dom";
import usePaginatedData from "../Utils/UsePagination";
import { useThemeColor } from "../Sidebar/SideBarApi";
import { customStyles, onMenuClose, onMenuOpen, truncateText } from "../Utils/CommonFuntion";
import { IconEye } from "@tabler/icons-react";
import { LeadStatusStyles } from "../Utils/StaticData";
import moment from "moment";

export default function LeadsGroups() {
  const { register, handleSubmit, control, reset, setValue, watch } = useForm();
  const {
      register: registerForm1,
      handleSubmit: handleSubmitForm1,
      watch: watchForm1,
      setValue: setValueForm1,
      reset: resetForm1,
      control: control1,
      formState: { errors: errorsForm1, isValid: isValidForm1 },
  } = useForm();
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const companyDetails = useSelector((state) => state?.login?.userDetails?.company);
  const [selectedRows, setSelectedRows] = useState([]);
  const [AssignUsers2, setAssignUsers2] = useState([]); 
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isApplyDisabled, setIsApplyDisabled] = useState(true);
  const [RowCheck, setRowCheck] = useState(false);
  const isFirstRender = useRef(true);
  const [RowId, setRowId] = useState([]);
  const [Company, setCompany] = useState([]);
  const [GroupsByCompany, setGroupsByCompany] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const navigate = useNavigate();
  const filterTimeout = useRef();
  const themeColor = useThemeColor();
  let companyId = watch("companyId");
  const searchValue = watchForm1("search");
  const leadStatusValue = watchForm1("leadStatus");
  const phoneNumber = watchForm1("phoneNumber");
  const user = watchForm1("user");
  const location = useLocation();

  useEffect(() => {
      setIsApplyDisabled(!(searchValue || leadStatusValue || phoneNumber || user));
    }, [searchValue, leadStatusValue, phoneNumber, user]);

  const initialFilterState = {
    p: 1,
    id: userDetails?._id || "",
    role: userDetails?.role?.roleName || "",
    status: "",
    companyId: userDetails?.company?._id || "",
  };

   const [filterObject, setFilterObject] = useState({
  ...initialFilterState,
  p: location.state?.restorePage || 1,
});

  const {
    filterData: LeadsData,
    pageNo,
    records,
    nextIsValid,
    prevIsValid,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    loader,
  } = usePaginatedData(1, location.state?.restoreRecords || 50, GetallLeads2API, filterObject);

  const assignToOptions =
    GroupsByCompany != undefined
      ? GroupsByCompany[0]?.map((groups) => ({
          value: groups?._id,
          label: groups?.grpName,
        }))
      : [{ value: "", label: "No data found" }];

  const assignToOptions2 =
    AssignUsers2 != undefined
      ? AssignUsers2.map((user) => ({
          value: user?._id,
          label: `${user?.first_name} ${user?.last_name} - ${user?.role?.roleName}`,
        }))
      : [{ value: "", label: "No data found" }];  

  // "Select All" functionality
  const handleSelectAll = (checked) => {
    if (checked) {
      const allRowIds = LeadsData?.map((row) => row?._id);
      setSelectedRows(allRowIds);
      setRowId(allRowIds);
      setRowCheck(true);
    } else {
      setSelectedRows([]);
      setRowCheck(false);
    }
  };

  // Function to select/deselect a single row
  const handleRowSelect = (rowId, checked) => {
    setSelectedRows((prevSelected) => {
      let updatedSelection;
      if (checked) {
        updatedSelection = [...prevSelected, rowId]; // Select the row
      } else {
        updatedSelection = prevSelected.filter((id) => id !== rowId); // Deselect the row
      }

      // Set RowCheck to true only if there are still selected rows
      setRowCheck(updatedSelection.length > 0);
      setRowId(updatedSelection);
      return updatedSelection;
    });
  };

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  // Function to handle view lead
  const HandleViewLead = (row) => {
    navigate("/teamleads-detail", { state: { leadData: row,fromPage: pageNo, restoreRecords: records }});
  };

  // Function to handle assign users
  const HandleAssignUsers = async (data) => {
    const payload = {
      leadIds: RowId,
      groupId: data?.assign_user?.value,
    };
    try {
      let response = await AddLeadGroupsAPI(payload);
      if (response?.status === 200) {
        toast.success(response?.data?.message);
        reset({assign_user: null, companyId: null });
        filterRecords();
        setRowCheck(false)
      } else {
        toast.error(response?.response?.data?.error);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const tableColumns = [
    {
      field: "select",
      header: LeadsData?.length > 0 && (
        <Checkbox
          checked={
            selectedRows?.length === LeadsData?.length && LeadsData?.length > 0
          }
          indeterminate={false} // Show indeterminate state
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      style: true,
      body: (row) => (
        <Controller
          name={`selected_${row.id}`}
          control={control}
          render={() => (
            <Checkbox
              checked={selectedRows.includes(row._id)}
              onChange={(e) => handleRowSelect(row._id, e.target.checked)}
            />
          )}
        />
      ),
    },
    {
      field: "createdAt",
      header: "Created At",
      style: true,
      body: (row) => (
        <h6>{row?.createdAt ? moment(row?.createdAt).format("DD-MM-YYYY") : "-----"}</h6>
      ),
    },
    {
      field: "location",
      header: "Location",
      style: true,
      className: "col-location",
      body: (row) => {
        const fullText = `${row?.city || ""}${row?.city && row?.state ? ", " : ""}${row?.state || ""}`;
        return (
          <>
            <h6 title={fullText}>
              {truncateText(fullText)}
            </h6>
            <h6>{row?.pincode || "----"}</h6>
          </>
        );
      },
    },
    {
      field: "fullName",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const fullName = `${row?.firstName || ""} ${row?.lastName || ""}`.trim();
        return (
          <h6 title={fullName || "-----"}>
            {truncateText(fullName, 30)}
          </h6>
        );
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => (
        <h6 title={row?.email || "-----"}>
          {truncateText(row?.email || "", 30)}
        </h6>
      ),
    },
    {
      field: "phoneNumber",
      header: "Phone Number",
      style: true,
      body: (row) => <h6>{row?.phoneNumber || "----"}</h6>,
    },
    {
      field: "alternateNumber",
      header: "Alternate Number",
      style: true,
      body: (row) => <h6>{row?.alternateNumber || "------"}</h6>,
    },
    {
      field: "leadSource",
      header: "Lead Source",
      style: true,
      body: (row) => <h6>{row?.leadSource || "-----"}</h6>,
    },
     {
      field: "product",
      header: "Product",
      style: true,
      body: (row) => <h6>{row?.product || "------"}</h6>,
    },
    userDetails?.role?.roleName === "SuperAdmin" && {
      field: "company",
      header: "Company",
      style: true,
      body: (row) => <h6>{row?.company?.companyName || "----"}</h6>,
    },
    {
      field: "assigned_to",
      header: "Assigned To",
      style: true,
      body: (row) => (
        <h6>
          {`${row?.assigned_to?.first_name || "----"} ${
            row?.assigned_to?.last_name || "----"
          }`}
        </h6>
      ),
    },
    {
          field: "followUpDetails",
          header: "FDetails",
          style: true,
          body: (row) => {
            const followDate = row?.followDate;
            const followTime = row?.followTime;
            const followDateDetails = (followDate) ? moment(row?.followDate).format("DD-MM-YYYY") : "-----";
            const followTimeDetails = (followTime) ? `${followTime}` : "-----";
            return(
              <>
                <h6>{followDateDetails}</h6>
                <h6>{followTimeDetails}</h6>
              </>
            );
          },
    },
    {
      field: "leadStatus",
      header: "Lead Status",
      style: true,
      body: (row) => <LeadStatusStyles leadStatus={row?.leadStatus} />,
    },
     {
      field: "remark",
      header: "Remark",
      style: true,
      body: (row) => <h6 className='break-words whitespace-pre-line min-w-[20rem]'>{row?.remark || "-----"}</h6>,
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              HandleViewLead(row);
            }}
            className="py-1 rounded-lg flex justify-center w-1/2"
          >
            <IconEye size={24} className="text-black" color="#000" stroke={1.5} />
          </button>
        </div>
      ),
    },
  ];

  const allowedFields = companyDetails?.allowedLeadTableFields || [];

  let filteredColumns = tableColumns;

  if (allowedFields.length > 0) {
    filteredColumns = tableColumns.filter((col) => {
      return (
        col.field === "select" ||
        col.field === "createdAt" ||
        col.field === "actions" ||
        allowedFields.includes(col.field)
      );
    });
  }

  const handleCompanySelect = async (id) => {
    setValue("assign_user", null);
    setSelectedGroup([]);
    try {
      setSelectedGroup(null);
      setValue("assign_user", null);
      const response = await GetGroupsByCompanyAPI({
        companyId:
          userDetails?.role?.roleName == "SuperAdmin"
            ? id
            : userDetails?.company?._id,
      });
      setGroupsByCompany([response?.data?.filteredData]);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const handleCompanySelect2 = async (id) => {
      const companyId = userDetails?.role?.roleName !== "SuperAdmin" ? userDetails?.company?._id : id;
      try {
        let response2 = await StaticUserAPI({
          id: userDetails?._id,
          role: userDetails?.role?.roleName,
          company: companyId,
        });
        console.log("Users by company response:", response2);
        setAssignUsers2(response2?.data?.filteredData);
      } catch (err) {
        console.log("Error", err);
      }
  };

  const getallCompany = async () => {
    try {
      if (userDetails?.role?.roleName == "SuperAdmin") {
        const res = await GetAllCompanyAPI(userDetails?.company?._id);
        setCompany(res?.data?.filteredData);
      } else {
        setCompany([]);
      }
    } catch (err) {
      console.log("Error:", err);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterRecords();
  }, [filterObject]);

  useEffect(() => {
    if (userDetails?.role?.roleName == "Admin") {
      handleCompanySelect(userDetails?.company?._id);
      handleCompanySelect2(userDetails?.company?._id);
    }
    getallCompany();
  }, []);

  const filterSubmit = async (data) => {
    const payload = {
      ...filterObject,
      company: data?.companyId ? data?.companyId : "",
      search: data?.search ? data?.search : "",
      phoneNumber: data?.phoneNumber ? data?.phoneNumber : "",
      leadStatus: data?.leadStatus ? data?.leadStatus : "",
      user: data?.user?.value ? data?.user?.value : ""
    };
    setFilterObject(payload);
  };
  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader} text-[27px] sm:text-[32px]`}>
              Leads Groups
            </h1>
          </div>
          <div className="bg-white rounded-xl mt-4">
            <form
              onSubmit={handleSubmitForm1(filterSubmit)}
              className="flex flex-col lg:flex-row gap-3"
            >
              {/* FILTERS DIV */}
              <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                {userDetails?.role?.roleName == "SuperAdmin" && (
                  <div>
                    <select
                      name="companyId"
                      placeholder="Company Name"
                      className={`${inputClass} !bg-slate-100 ${
                        companyId == "" ? "text-slate-400" : ""
                      }`}
                      {...registerForm1("companyId")}
                      onChange={(e) => {
                        handleCompanySelect2(e.target.value);
                      }}
                    >
                      <option value="">Company Name</option>

                      {Company?.map((company) => (
                        <option
                          className="text-black"
                          key={company?._id}
                          value={company?._id}
                        >
                          {company?.companyName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div>
                  <input
                    type="text"
                    placeholder="Enter Leads Name / State"
                    className={inputClass}
                    {...registerForm1("search")}
                  />
                </div>

                <div>
                  <select
                    name="Status"
                    placeholder="Lead Status"
                    className={`${inputClass} !bg-slate-100`}
                    {...registerForm1("leadStatus")}
                  >
                    <option value="">Leads Status</option>
                    <option value="CallBack">Call back</option>
                    <option value="FollowUp">Follow Up</option>
                    <option value="Pending">Pending</option>
                    <option value="Rejected">Rejected</option>
                    <option value="Ringing">Ringing</option>
                    <option value="NotReachable">Not Reachable</option>
                    <option value="SwitchedOff">Switched off</option>
                    <option value="InvalidNumber">Invalid Number</option>
                    <option value="DealDone">Deal Done</option>
                  </select>
                </div>

                <div>
                  <Controller
                    name="user"
                    control={control1}
                    render={({ field }) => (
                      <Select
                        {...field}
                        styles={customStyles}
                        aria-labelledby="aria-label"
                        inputId="aria-example-input"
                        onMenuOpen={onMenuOpen(setIsMenuOpen)}
                        onMenuClose={onMenuClose(setIsMenuOpen)}
                        options={assignToOptions2}
                        placeholder="Select User"
                        maxMenuHeight={220}
                      />
                    )}
                  />
                </div>

                <div>
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    className={inputClass}
                    {...registerForm1("phoneNumber")}
                  />
                </div>
              </div>

              {/* BUTTON DIV */}
              <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                <button
                  type="submit"
                  className={`${formBtn1} ${
                    isApplyDisabled
                      ? "opacity-50 cursor-not-allowed"
                      : "bg-base-color"
                  }`}
                  disabled={isApplyDisabled}
                >
                  Apply
                </button>

                <button
                  type="button"
                  onClick={() => {
                    resetForm1({
                      user: null,
                      companyId: null,
                      search: null,
                      leadStatus: null,
                      phoneNumber: null,
                    });
                    setFilterObject(initialFilterState);
                  }}
                  className={`${formBtn2} ${
                    isApplyDisabled
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={isApplyDisabled}
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
          {RowCheck && (
            <div className="bg-white rounded-xl mt-6">
              <form
                onSubmit={handleSubmit(HandleAssignUsers)}
                className="flex flex-col lg:flex-row gap-2"
              >
                <div className="w-full flex flex-col items-center gap-y-2 sm:flex-row sm:items-center sm:gap-x-4">
                  {userDetails?.role?.roleName == "SuperAdmin" && (
                    <div className="w-full sm:w-auto max-w-xs">
                      <select
                        name="company_id"
                        placeholder="Company Name"
                        className={`${inputClass} !bg-slate-100 w-full`}
                        {...register("companyId")}
                        onChange={(e) => handleCompanySelect(e.target.value)}
                      >
                        <option value="">Select Company Name</option>
                        {Company?.map((data) => (
                          <option
                            className="text-black"
                            key={data?._id}
                            value={data?._id}
                          >
                            {data?.companyName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="w-full sm:w-auto max-w-xs">
                    <div className="form-group">
                      <Controller
                        name="assign_user"
                        control={control}
                        render={({ field }) => (
                          <Select
                            value={selectedGroup}
                            options={
                              assignToOptions != undefined
                                ? assignToOptions
                                : []
                            }
                            placeholder="Select Groups"
                            styles={customStyles}
                            maxMenuHeight={220}
                            menuPlacement="auto"
                            onChange={(selectedOption) => {
                              setSelectedGroup(selectedOption); // Update form state
                              setValue("assign_user", selectedOption);
                            }}
                            {...field}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="flex justify-center sm:justify-start w-full sm:w-auto">
                    <button
                      type="submit"
                      className={`${formBtn1} w-full sm:w-auto text-center`}
                    >
                      Assign
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
          <div className="mt-4">
            <Table
              key={selectedRows.length}
              columns={filteredColumns}
              data={LeadsData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              records={records}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              loading={loader}
            />
          </div>
        </div>
      </div>
    </>
  );
}
